module.exports = __webpack_public_path__ + "static/media/ekriti.aec3019b.md";